(ns frontend.view.modals.kpi-email.events)

(defn reset-state!
  [{:keys [state email-title-attribute email-copy-attribute
           default-email-copy default-email-title]}]
  (let [value {email-title-attribute default-email-title
               email-copy-attribute default-email-copy
               :edit {email-title-attribute default-email-title
                      email-copy-attribute  default-email-copy}}]
    (reset! state value)))

(defn show-edit!
  [state]
  (swap! state assoc :edit? true))

(defn save-email!
  [{:keys [state email-copy-attribute email-title-attribute]}]
  (let [edit-vals (:edit @state)
        email-title (get edit-vals email-title-attribute)
        email-copy (get edit-vals email-copy-attribute)]
    (swap! state assoc
      email-title-attribute
      email-title
      email-copy-attribute
      email-copy
      :edit?
      nil)))
